import { FC, useContext } from 'react';
import styled from 'styled-components';
import AuthContext from '../../../context/AuthContext';
import { getOrganizations } from '../../utils/getOrganization';

const Container = styled.div(({ theme }) => {
  const { color } = theme.new;

  return `
    width: 100%;
    padding: 0.5rem;
    background-color: ${color.brand[1].dark};
    color: ${color.neutral[0]};
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    line-height: 1;
  `;
});

const Label = styled.label(({ theme }) => {
  const { color, type } = theme.new;
  return `
    display: block;
    color: ${color.neutral[0]};
    font-weight: ${type.weight.bold};
    font-family: ${type.face};
    margin: 0;
  `;
});

const Select = styled.select(({ theme }) => {
  const { color, type } = theme.new;
  return `
    display: block;
    color: ${color.neutral[9]};
    font-weight: ${type.weight.bold};
    font-family: ${type.face};
    background-color: ${color.neutral[0]};
    padding: 0.25rem 0.5rem;
    line-height: 1;
    border: 1px solid ${color.neutral[9]};

    option {
      vertical-align: middle;
    }
  `;
});

interface OrganizationDropdownProps {
  activeOrganization?: string;
  selectHandler: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const OrganizationDropdown: FC<OrganizationDropdownProps> = ({ activeOrganization, selectHandler }) => {
  const auth = useContext(AuthContext);
  const organizations = getOrganizations(auth);
  const optionLoop = organizations.map((organization) => {
    return <option value={organization.id}>{organization.name}</option>;
  });

  if (import.meta.env.VITE_ENVIRONMENT === 'localhost' || import.meta.env.VITE_ENVIRONMENT === 'stage') {
    return (
      <Container>
        <Label htmlFor="org-selector">Select active organization</Label>
        <Select id="org-selector" value={activeOrganization} onChange={selectHandler}>
          {optionLoop}
        </Select>
      </Container>
    );
  }
  return <></>;
};

export default OrganizationDropdown;
